import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { SearchableLocationForm, SearchablePolygonPointForm } from '@mark43/cad-api';
import { FilterSummary } from './filter-summary';
import { FiltersSummary } from './filters-summary';
import { formatSubpremises } from './form-value-formatters';

export function SearchableLocationFilterSummary({
    title,
    location,
    locationVerification,
    polygonPoints,
}: {
    title: string;
    location?: SearchableLocationForm;
    locationVerification?: string;
    polygonPoints: SearchablePolygonPointForm[];
}) {
    const { subpremiseSupport } = useEnabledFeatures();

    const subpremiseString = formatSubpremises(location?.subPremiseDtos ?? []);

    return (
        <FiltersSummary title={title}>
            <FilterSummary label="Street Address" stringValue={location?.streetAddress} />
            {!subpremiseSupport && (
                <FilterSummary label="Apt, Unit" stringValue={location?.subPremise} />
            )}
            {subpremiseSupport && (
                <FilterSummary label="Sub-premises" stringValue={subpremiseString} />
            )}
            <FilterSummary label="Subdivisions" options={location?.subdivisions} />
            <FilterSummary label="City" stringValue={location?.city} />
            <FilterSummary label="State" option={location?.state} />
            <FilterSummary label="ZIP" stringValue={location?.zip} />
            <FilterSummary label="Country" option={location?.country} />
            <FilterSummary
                label="Intersection Street 1"
                stringValue={location?.intersectionStreet1}
            />
            <FilterSummary
                label="Intersection Street 2"
                stringValue={location?.intersectionStreet2}
            />
            <FilterSummary label="Verification" stringValue={locationVerification} />
            <FilterSummary label="Latitude" numberValue={location?.latitude} />
            <FilterSummary label="Longitude" numberValue={location?.longitude} />
            <FilterSummary label="Radius (Feet)" numberValue={location?.radiusInFeet} />
            <FilterSummary
                label="Polygon"
                stringValues={polygonPoints.map(({ latitude, longitude }) =>
                    latitude && longitude ? `${latitude}/${longitude}` : undefined
                )}
            />
        </FiltersSummary>
    );
}
